import { render, staticRenderFns } from "./landlordOrder.vue?vue&type=template&id=32305c6f&scoped=true&"
import script from "./landlordOrder.vue?vue&type=script&lang=js&"
export * from "./landlordOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32305c6f",
  null
  
)

export default component.exports